<template>
  <div>
    <!-- Modal -->
    <div class="modal fade" id="addQuoteRequestModal" ref="modalEle" tabindex="-1" role="dialog"
      aria-labelledby="modelTitleId" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Ruch {{ movement?.document_number }}</h5>
            <button type="button" class="close ms-auto" data-bs-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body pt-3">
            <h6 class="text-warning pb-2" v-if="!isFilled">Najwyraźniej nie wszystkie pola zostały wypełnione.
              Możesz je teraz wypełnić, aby zapisać w bazie.</h6>
            <label class="form-label">Powód</label>
            <input type="text" v-model="form.purpose" class="form-control form-control-sm">
            <div v-if="!movement?.document_number?.startsWith('PW')">
              <label class="form-label">Osoba wystawiająca</label>
              <input type="text" v-model="form.who_issuing" class="form-control form-control-sm">
            </div>
            <div v-else>
              <label class="form-label">Osoba przyjmująca</label>
              <input type="text" v-model="form.who_issuing" class="form-control form-control-sm">
            </div>
            <div v-if="movement?.document_number?.startsWith('WZ')">
              <div class="position-relative">
                <label class="form-label" for="customer_search">Wybierz klienta:</label>

                <input id="customer_search" type="text" class="form-control form-control-sm" v-model="customerSearch"
                  placeholder="Wpisz nazwę klienta..." @focus="showDropdown = true" @blur="hideDropdown" />

                <div v-if="showDropdown && filteredCustomers.length"
                  class="border rounded bg-white position-absolute w-100 z-3"
                  style="max-height: 200px; overflow-y: auto;">
                  <div v-for="customer in filteredCustomers" :key="customer.id" class="px-2 py-1 hover-bg"
                    style="cursor: pointer;" @mousedown.prevent="selectCustomer(customer)">
                    {{ customer.name }}
                  </div>
                </div>
              </div>


              <label class="form-label">Dane klienta</label>
              <textarea v-model="form.who_buying" class="form-control form-control-sm" rows=4></textarea>
            </div>

            <div v-if="!movement?.document_number?.startsWith('PW') && !movement?.document_number?.startsWith('RW')">
              <label class="form-label">Osoba odbierająca</label>
              <input type="text" v-model="form.who_receiving" class="form-control form-control-sm">
            </div>
            <label class="form-label">Data podpisania dokumentu</label>
            <input type="date" v-model="form.signed_date" class="form-control form-control-sm">

            <label class="form-label">Dodatkowy komentarz</label>
            <input type="text" v-model="form.additional_comment" class="form-control form-control-sm">

            <div class="float-end">
              <button class="btn btn-primary btn-sm mt-4" type="button" :disabled="generatingPDF"
                @click="generateDocument">
                <span v-if="!generatingPDF">
                  Generuj PDF
                </span>
                <span v-else>
                  Generuję...
                </span>
                <div v-if="generatingPDF" class="ms-2">
                  <div class="spinner-border spinner-border-reverse align-self-center loader-xs text-secondary"
                    style="width: 1rem; height: 1rem; border-width: 0.15em;">
                    Ładowanie...
                  </div>
                </div>
              </button>
            </div>

          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { Modal, Tooltip } from "bootstrap";
import { useForm, usePage } from "@inertiajs/vue3";
import { DatePickerComponent } from "@syncfusion/ej2-vue-calendars";
import Index from "../../OrderLists/Index.vue";

export default {
  components: { Index, 'ejs-datepicker': DatePickerComponent },
  props: {
    movement: Object,
    isFilled: Boolean,
    customers: {
      type: Array,
      default: () => []
    },
    item: Object
  },

  data() {

    return {
      generatingPDF: false,
      documentType: 'pw',
      customerSearch: '',
      showDropdown: false,
      form: useForm({
        movement_id: this.movement?.id,
        additional_comment: null,
        signed_date: null,
        who_receiving: null,
        who_issuing: null,
        purpose: null,
        who_buying: null,
        teamName: this.item?.team_name ?? null,
        projectName: this.item?.project_short_name ?? null,
      })
    }
  },
  computed: {
    filteredCustomers() {
      if (!this.customerSearch) return this.customers

      return this.customers.filter(c =>
        c.name.toLowerCase().includes(this.customerSearch.toLowerCase())
      )
    }
  },
  watch: {
    movement: {
      immediate: true,
      handler(newVal) {
        if (!newVal) {
          return;
        }

        this.form.movement_id = newVal.id;
        this.form.additional_comment = newVal.additional_comment ?? null;
        this.form.signed_date =
          newVal.signed_date || new Date().toISOString().split('T')[0];
        this.form.who_receiving = newVal.who_receiving ?? null;
        this.form.who_issuing = newVal.who_issuing ?? null;
        this.form.purpose = newVal.purpose ?? null;
        this.form.customer_id = newVal.customer_id ?? null;
        this.form.who_buying = newVal.who_buying ?? null;

        const customer = this.customers.find(
          c => c.id === newVal.customer_id
        );

        this.customerSearch = customer?.name ?? '';
      }
    }
  },


  async mounted() {
    this.modalObj = new Modal(this.$refs.modalEle);
  },

  methods: {
    selectCustomer(customer) {
      this.form.customer_id = customer.id
      this.customerSearch = customer.name
      this.showDropdown = false

      const data = customer.customers_data || {}

      const lines = [
        customer.name,
        data.address,
        [data.zip_code, data.city].filter(Boolean).join(' ')
      ].filter(Boolean)

      this.form.who_buying = lines.join('\n')
    },

    hideDropdown() {
      setTimeout(() => {
        this.showDropdown = false
      }, 150)
    },

    async generateDocument() {
      this.generatingPDF = true;
      try {
        const response = await axios.post(route('warehouse-movements.previewPDF'), this.form, {
          responseType: 'blob',
        });

        const blob = new Blob([response.data], { type: 'application/pdf' });
        const pdfUrl = URL.createObjectURL(blob);
        window.open(pdfUrl, '_blank');
      } catch (error) {
        console.error('Error generating PDF preview:', error);
      } finally {
        this.generatingPDF = false;
      }
    },

    hasError(field) {
      return this.errors && this.errors[field];
    },

    show() {
      if (this.modalObj) {
        this.modalObj.show();

        this.$nextTick(() => {
          if (this.isFilled) {
            this.generateDocument();
          }
        })
      }
    },

    hide() {
      if (this.modalObj) {
        this.modalObj.hide();
      }
    },
  }
}
</script>